const HIGH_END_COLOUR = 'var(--color-status-success)';
const LOW_END_COLOUR = 'var(--color-status-danger)';

const computeScoreColor = ({
  value,
  colourConfig,
}: {
  value: unknown;
  colourConfig?: FleetOps.BonusScoreColourConfig;
}): string | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  const numValue = value as number;

  if (
    colourConfig?.mode === 'manual' &&
    colourConfig.thresholds &&
    colourConfig.thresholds.length > 0
  ) {
    const { direction } = colourConfig;
    const sorted = [...colourConfig.thresholds].sort((a, b) => a - b);
    const minVal = sorted[0];
    const maxVal = sorted[sorted.length - 1];
    const range = maxVal - minVal;
    if (range === 0) {
      return 'hsl(60, 70%, 45%)';
    }
    const normalised = Math.min(1, Math.max(0, (numValue - minVal) / range));
    const isHighEnd =
      direction === 'green-to-red' ? normalised <= 0 : normalised >= 1;
    if (isHighEnd) {
      return HIGH_END_COLOUR;
    }
    const isLowEnd =
      direction === 'green-to-red' ? normalised >= 1 : normalised <= 0;
    if (isLowEnd) {
      return LOW_END_COLOUR;
    }
    const hue =
      direction === 'green-to-red' ? (1 - normalised) * 120 : normalised * 120;
    return `hsl(${hue}, 70%, 45%)`;
  }

  // Automatic (default): 0 = red, 100 = green
  const clamped = Math.min(100, Math.max(0, numValue));
  if (clamped >= 100) {
    return HIGH_END_COLOUR;
  }
  if (clamped <= 0) {
    return LOW_END_COLOUR;
  }
  const hue = clamped * 1.2;
  return `hsl(${hue}, 70%, 45%)`;
};

export default computeScoreColor;
